module.exports = __webpack_public_path__ + "static/media/background-left-en-cards.16686744.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/background-left-en-cards.png
 ** module id = 87
 ** module chunks = 0
 **/